import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaDecretos from '../../components/leis/listar/decretos';


function DecretosScreen () {
    return (
        <Fragment>
            <Head titulo="Decretos do Município de Macuco"/>
            <Header />
            <Container>
                <ListaDecretos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DecretosScreen;